
export default {
    name: "language_selection",
    props: ["selectedLang"],
    props: {
        selectedLang: { default: "en" },
        textColor: { default: "text-black" },
        textFont: { default: "text-sm sm:text-base md:text-xl" },
        dividerColor: { default: "bg-black" },
    },
    methods: {
        onSelectLang(item){
            this.$emit("update:selectedLang", item);
        },
    },
}
